import { render } from "./sidecontentnews.vue?vue&type=template&id=36e8aff6"
import script from "./sidecontentnews.vue?vue&type=script&lang=js"
export * from "./sidecontentnews.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__